import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'components/layout';
import { FormMonacoEditor } from 'components/common';
import { Box, Typography, Grid, Divider, Skeleton } from '@mui/material';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';

const TemplateAbout = ({
  methods,
  policies,
  fieldData,
  fieldDataConst,
  projects,
  isLoaded,
  onChangeProject,
  showActions = true,
  isEdit = false
}) => {
  const [t] = useTranslation();
  const { control, getValues,setValue } = methods;
  const getProjectName = (id) => {
    if (!id) return '';
    const project = projects.find(p => p.value === id);
    return project.label;
  }
  const changeCredencial= (items)=>{
    //no sirve
    //console.log(items);
    //let hash = {};
    //items = items.filter(o => hash[o.value] ? false : hash[o.value] = true);
    //setValue("credential", items);
  }

  const fields = [
    { policy: policies.name, value: getValues(policies.name.name)},
    { policy: {...policies.project, disabled: true}, options: projects, handleOnChange: onChangeProject, value: getProjectName(getValues(policies.project.name))},
    { policy: policies.jobType, options: fieldDataConst.jobType, value: getValues(policies.jobType.name)},
    { policy: policies.inventory, options: fieldData.inventories, isLoaded, enabledLanguage: false, value: getValues(policies.inventory.name)},
    { policy: policies.playbook, options: fieldData.playbooks, isLoaded, enabledLanguage: false, value: getValues(policies.playbook.name)},
    { policy: policies.credential, handleOnChange: changeCredencial, options: fieldData.credentials, isLoaded, enabledLanguage: false, value: getValues(policies.credential.name)},
    { policy: policies.forks, value: getValues(policies.forks.name)},
    { policy: policies.limit, value: getValues(policies.limit.name)},
    { policy: policies.levelDetail, options: fieldDataConst.levelDetail, value: getValues(policies.levelDetail.name)},
    { policy: policies.timeout, value: getValues(policies.timeout.name)},
    { policy: policies.commandLine, value: getValues(policies.commandLine.name)},
    { policy: policies.showChanges, value: (getValues(policies.showChanges.name)) ? t('common.labels.yes'): t('common.labels.no')},
    { policy: policies.consultExecution, value: (getValues(policies.consultExecution.name)) ? t('common.labels.yes'): t('common.labels.no')},
  ];

  const checkboxs = [
    { policy: policies.enabledPrivileges, value: (getValues(policies.enabledPrivileges.name)) ? <CheckOutlinedIcon color="primary" />: <ClearOutlinedIcon color="primary" /> },
    { policy: policies.enabledJobs, value: (getValues(policies.enabledJobs.name))             ? <CheckOutlinedIcon color="primary" />: <ClearOutlinedIcon color="primary" /> },
    { policy: policies.useCache, value: (getValues(policies.useCache.name))                   ? <CheckOutlinedIcon color="primary" />: <ClearOutlinedIcon color="primary" /> }
  ];

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Typography variant="h6" sx={{ padding: '8px 0px' }}>
        {t('templateList.stepper.about.title')}
      </Typography>
      <Grid container spacing={2}>
        { showActions && fields.map((field) => (
          <React.Fragment key={field.policy.id}>
            { !field?.isLoaded ? (
              <Grid item xs={12} 
                    sm={field.policy.name == 'playbook'?12:6} 
                    md={field.policy.name == 'playbook'?12:4} 
                    lg={field.policy.name == 'playbook'?12:3}>
                { field.handleOnChange ?
                  (
                    <Input
                      {...field.policy}
                      control={control}
                      options={field.options}
                      sx={{ width: '100%' }}
                      onChange = { field.handleOnChange }
                      setValue={setValue}
                      getValues = {getValues}
                    />
                  ) : (
                    <Input
                      {...field.policy}
                      control={control}
                      options={field.options}
                      sx={{ width: '100%' }}
                      setValue={setValue}
                      getValues = {getValues}
                    />
                  )
                }
              </Grid>
            ) : (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Skeleton
                  sx={{ marginBottom: 1 }}
                  variant="text"
                  animation="wave"
                  width="60%"
                />
                <Skeleton height="40px" variant="rounded" animation="wave" />
              </Grid>
            )}
          </React.Fragment>
        ))}

        { !showActions && fields.map((field) => (
          <React.Fragment key={field.policy.id}>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography variant="subtitle1">
                  {t(field.policy.label)}
                </Typography>
                <Typography variant="body1">
                  {field.value}
                </Typography>
              </Grid>
          </React.Fragment>
        ))}

        {showActions ? (
          <Grid item xs={12}>
            <Input
              {...policies.description}
              control={control}
              sx={{ width: '100%' }}
            />
          </Grid>
          ): (
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              {t(policies.description.label)}
            </Typography>
            <Typography variant="body1">
              {getValues(policies.description.name)}
            </Typography>
          </Grid>
        )}
      </Grid>
      <Divider sx={{ padding: 2 }} />
      <Typography variant="h6" sx={{ padding: '8px 0px' }}>
        {t('templateList.stepper.about.secondTitle')}
      </Typography>
      { showActions && checkboxs.map((checkbox) => (
          <Input
            sx={{ marginLeft: -1 }}
            key={checkbox.policy.id}
            {...checkbox.policy}
            control={control}
          />
      ))}

      { !showActions && checkboxs.map((checkbox) => (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
          <Typography variant="body1">
            {checkbox.value}
          </Typography>
          <Typography variant="subtitle1">
            {t(checkbox.policy.label)}
          </Typography>
        </Box>
      ))}
      <FormMonacoEditor
        label={policies.additionalVariables.label}
        name={policies.additionalVariables.name}
        helperText={policies.additionalVariables.helperText}
        methods={methods}
        language='json'
      />
    </Box>
  );
};

export default TemplateAbout;
